import React from 'react';
import DashboardActionsIconBox from 'common/components/dashboard-actions-icon-box';
import {reactDOMInject} from 'common/utils/dom-util';

reactDOMInject(
  DashboardActionsIconBox,
  '.dashboard-actions-icon-box',
  (props) => ({
    dashboard: JSON.parse(props.dashboard),
  }),
);

window.addEventListener('dashboard-settings-updated', (evnt) => {
  const {dashboard} = evnt.detail;

  const props = {
    dashboard,
  };

  reactDOMInject(
    DashboardActionsIconBox,
    '.dashboard-actions-icon-box',
    () => props,
  );
});
